<template>
  <div>
    <px-view-header v-if="!isModalView"
                    title="Detalhes da compra" title-class="font-weight-bold"
                    :breadcrumbs="breadcrumbs">
      <template v-slot:before>
        <v-btn class="mb-4 mr-1" icon x-large color="primary" @click="onClickBack">
          <v-icon>
            mdi-arrow-left
          </v-icon>
        </v-btn>
      </template>
    </px-view-header>
    <div v-if="loading || loadingForm">
      <px-circular-loading/>
    </div>
    <div v-if="!loading && !loadingForm && compra">
      <px-compra-detalhes-dados-basicos :compra="compra" @movimentar="onMovimentar"/>
      <px-compra-detalhes-tabs :compra="compra"/>
      <px-compra-detalhes-produtos :compra="compra"
                                   :campos-personalizados="camposPersonalizados"
                                   :campos-hidden="camposHidden"
                                   @update="onMovimentar"/>
      <px-compra-detalhes-mensagens-personalizadas v-if="checkMessages"
                                                   :compra="compra"/>
      <px-compra-mensagem class="mt-3" :compra="compra" v-if="compra.fornecedor.hasUsers"/>
      <px-compra-detalhes-logs :id-compra="compra.id" v-if="hasIntegracaoAtiva"/>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import EntidadeCamposPersonalizadosService from '@/modules/campos-personalizados/entidade-campos-personalizados-service';
import CompraDetalhesDadosBasicos from './CompraDetalhesDadosBasicos.vue';
import CompraDetalhesLogs from './logs-compra/CompraDetalhesLogs.vue';
import CompraDetalhesProdutos from './CompraDetalhesProdutos.vue';
import CompraDetalhesTabs from './CompraDetalhesTabs.vue';
import CompraMensagem from '../CompraMensagem.vue';
import CompraService from '../compra-service';
import CompraDetalhesMensagensPersonalizadas from './CompraDetalhesMensagensPersonalizadas.vue';
import EntidadeCamposCompraService from '../../erp-campos/entidade-campos-compra-service';

export default {
  props: {
    isModalView: {
      type: Boolean,
      default: false,
    },
    compraIdProp: {
      type: [String, Number],
    },
  },
  data() {
    return {
      compra: null,
      loading: false,
      loadingForm: false,
      compraId: null,
      backLink: this.$route.query.backLink,
      camposPersonalizados: null,
      camposHidden: null,
      breadcrumbs: [
        { text: 'Gestão de compras' },
        { text: 'Compras', to: '/compras' },
        { text: 'Detalhes' },
      ],
    };
  },
  computed: {
    ...mapGetters('entidade', ['hasIntegracaoAtiva', 'idEntidade', 'erpCamposIntegracao']),
    checkMessages() {
      return this.compra.mensagensPersonalizadas
      && this.compra.mensagensPersonalizadas.length;
    },
  },
  methods: {
    onClickBack() {
      if (this.backLink) {
        this.$router.push({ path: this.backLink });
        return;
      }
      this.$router.push({ name: 'main.compras' });
    },
    getCompra() {
      this.loading = true;
      CompraService.getCompraCompleto(this.compraId)
        .then((response) => {
          this.compra = response.data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getCamposPersonalizados() {
      EntidadeCamposPersonalizadosService.getCamposPersonalizadosCompraById(this.idEntidade)
        .then((campos) => {
          this.camposPersonalizados = campos;
        });
    },
    getCamposHidden() {
      EntidadeCamposCompraService.getCamposHidden(this.erpCamposIntegracao)
        .then((campos) => {
          this.camposHidden = campos;
        });
    },
    onMovimentar() {
      this.getCompra();
    },
  },
  created() {
    this.compraId = this.compraIdProp || this.$route.params.id;

    this.loadingForm = true;
    Promise.all([
      this.getCompra(),
      this.getCamposPersonalizados(),
      this.getCamposHidden(),
    ])
      .finally(() => {
        this.loadingForm = false;
      });
  },
  components: {
    pxCompraDetalhesDadosBasicos: CompraDetalhesDadosBasicos,
    pxCompraDetalhesProdutos: CompraDetalhesProdutos,
    pxCompraDetalhesTabs: CompraDetalhesTabs,
    pxCompraMensagem: CompraMensagem,
    pxCompraDetalhesLogs: CompraDetalhesLogs,
    pxCompraDetalhesMensagensPersonalizadas: CompraDetalhesMensagensPersonalizadas,
  },
};
</script>
